
import {mapState, mapGetters, mapMutations, mapActions} from 'vuex';
import conf from './../../config/base.js';
import {getDepponReimBurseType,operateInvoice,tip} from '@/common/js/common.js';
import dataLack from '@/components/dataLack'

import {

invoiceTitleType,
documentTypeArray,

invoiceStatusArray,
invoiceReimbursementStatus,
discernStatus,
invoiceCheckStatus,
tenantCode,
depponReimBurseType,
invoiceExtractStatus,
} from '@/common/js/const';
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Box from 'vux/src/components/box/index.vue'
import Group from 'vux/src/components/group/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Spinner from 'vux/src/components/spinner/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Search from 'vux/src/components/search/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'


import scrollerEdit from './scroller-edit'
export default {

directives: {
TransferDom,
},
components: {
Box,
Group,
scrollerEdit,


PopupPicker,
Datetime,
Scroller,
Spinner,

Cell,
CellBox,

XHeader,
Flexbox,
FlexboxItem,
Search,
CheckIcon,
XButton,
dataLack,
},
watch:{
value:function (val) {
console.log(val)
if(val == ''){
this.searchLoadDataAndHideMask()
}
}
},
data() {
return {
showSignFlag: false,
invoicesListObject: {
50001010: '火车票',
50001011: '出租车票',
50001009: '行程单',
50001013: '定额发票',
50001001: '机动车发票',
50001016: '客运汽车票',
50001015: '二手车票',
40001001: '卷票',
20001001: '普票',

10001001: '专票',

30001001: '电子普票',

30001002: '通行费票',
90009999: '票据文档',
90001007: '结算单',
90001006: '结算单',
10: '多票影像'
},
viewType:'single',
paddingClass: 'pd46',
depponReismType: depponReimBurseType.personal,
invoiceExtractStatus: invoiceExtractStatus,
depponReimBurseType: depponReimBurseType,
optClass: 'text-muted',
isWechat: ____isWechatBrowser(),
topHeight: ____hasHeader ? '46px' : '0px',
searchResults: [],
searchKey: '',

invoiceReimbursementStatus: invoiceReimbursementStatus,
discernStatus: discernStatus,
invoiceCheckStatus: invoiceCheckStatus,

showDocumentTypePicker: false,
documentTypePickerValue: [],
documentTypeList: [],
documentTagList: [],
showDocumentTagPicker: false,
showDocumentStatusPicker: false,
documentStatusPickerValue: [],
documentStatusList: [],

totalInfo: '', // 共4张发票，累计金额￥2000.12
invoices: [],
latestInvoiceViewId: '', // 每次点击进入详情，都要给此值赋值

scrollerHeight: ____invoiceScrollerHeight - (this.$route.meta.showTabbar ? 55 : 0) + 'px',
scrollerStatus: {
pullupStatus: 'default',
pulldownStatus: 'default',
},
pullupEnabled: true,
scrollerPullupConfig: {
content: this.$t('上拉加载更多'),
downContent: this.$t('松开加载'),
upContent: this.$t('上拉加载更多'),
loadingContent: this.$t('加载中'),
height: 50,
autoRefresh: false,
},
scrollerPulldownConfig: {
content: this.$t('下拉刷新'),
downContent: this.$t('松开刷新'),
upContent: this.$t('松开刷新'),
loadingContent: this.$t('加载中'),

height: 50,

autoRefresh: false,
},
search: {
depponTag: '',
type: this.$t('分类'),
typeId: '',
status: this.$t('状态'),
statusId: '',
date: this.$dateFormat(new Date(), 'YYYYMMDD'),
dateDisplayName: this.$dateFormat(new Date(), 'YYYY-MM'), // this.$t("日期"),
pageIndex: 1,
pageSize: 10,
keyword: '',
},
browserType: 'mobile',

allSelect: false,
showSelect: false,
value: '',
};
},
created() {
},
activated() {
bus.$emit("setHeader", 'navbar');
var $self = this;
$self.depponReismType = getDepponReimBurseType();
if ($self.depponReismType === depponReimBurseType.BP) {
$self.paddingClass = 'pd102';
}

if (!____hasHeader) {
$self.topHeight = '0px';
} else {
$self.topHeight = '46px';
}

var needRefresh = $self.$route.query.p_refresh;






$self.refresh();


$self.ACTION_setInvoiceIndexReload({
type: null,
reserve: '',
});

$self.browserType = ____browserRedirect();
},
/**计算属性 将状态表中的数据 映射出来*/
computed: {
...mapState({
STATE_InvoiceIndexReload: state => state.invoice.invoiceIndexReload,
}),
isHISUNORHANHUI() {
const getSource = window.localStorage.getItem('source');
return getSource === "HISUN" || getSource === 'futureland';
},
},
filters: {},
/**初始化的时候调用  类似于 ready */
mounted() {
var $self = this;

$self.documentTypeList = [documentTypeArray];


this.checkWxWork()
let source = this.getSource()
var documentStatusArray = invoiceStatusArray.filter(function (item) {
if (conf.autoLoginInfo.source === 'futureland') {
return item.value !== 'reimbursement_-1' && item.value !== 'reimbursement_1';
}else if(source === 'HISUN'){
return item.value !== 'reimbursement_0' && item.value !== 'reimbursement_2';
} else {
return true;
}
});
$self.documentStatusList = [documentStatusArray];
$self.$nextTick(() => {
$self.$refs.scroller1.reset({top: 0});
});

if ($self.isWechat) {
$self.search.statusId = 'reimbursement_-1';
$self.search.status = '未报销';
$self.documentStatusPickerValue.push($self.search.statusId);
}
$self.loadData(true);
let highSearch =  (touch) => {
return  () => {
this.$refs.headerSearch.isCancel = false
touch()
}
}
this.$refs.headerSearch.touch = highSearch(this.$refs.headerSearch.touch)
if (localStorage.getItem('allowCheckSignFlag') === 'true') {
this.showSignFlag = true;
}
},
methods: {
...mapActions({
ACTION_setPageLoadingTrue: 'common_ac_setPageLoadingTrue',
}),
...mapActions({
ACTION_setPageLoadingFalse: 'common_ac_setPageLoadingFalse',
}),
...mapActions({
ACTION_setInvoiceIndexReload: 'invoice_ac_setinvoiceIndexReload',
}),
getSource(){
return localStorage.getItem('source')
},
setSwiperBtn(item) {
return [{
content: '删除',
style: {
background: 'red',
color: '#fff',
display: "flex",
'align-items': "center"
},
handler: () => this.deleteInvoice(item)
}]
},
deleteInvoice(invoice) {
if(!operateInvoice(invoice,'del')){
return false
}
this.$vux.confirm.show({
title: this.$t('提示'),
content: this.$t('删除警告'),
confirmText: this.$t('确定'),
cancelText: this.$t('取消'),
onCancel() {
},
onConfirm: () => {
let params = {
};
if (invoice.documentType == "10") {
params.taskId = invoice.__data.taskId
} else {
params.invoiceId = invoice.__data.invoiceId
}
this.$webapi.deleteInvoice(params).then(res => {
this.$clog(res.data);
this.$vux.toast.show({
text: res.data.msg,
type: 'text',
});
if (res.data.status == 1) {
this.loadData(true);
}
});
},
});
},

loadMore() {
var $self = this;
$self.loadData(false, function () {
setTimeout(() => {
$self.$refs.scroller1.donePullup();
}, 1200);
});
},

refresh() {
var $self = this;
$self.loadData(true, function () {
setTimeout(function () {
$self.$nextTick(() => {
setTimeout(() => {
$self.$refs.scroller1.donePulldown();
$self.pullupEnabled && $self.$refs.scroller1.enablePullup();
}, 10);
});
}, 1200);
});
},



reloadCurrentPageData(type, callback) {
var $self = this;
if ($self.latestInvoiceViewId == '') {
return false;
}
if (type == '2' || type == 2) {
$self.invoices = $self.invoices.filter(function (tll) {
return tll.__id != $self.latestInvoiceViewId;
});
return false;
}

var nowTime = new Date().getTime();

$self.$webapi
.oneInvoice({
invoiceId: $self.latestInvoiceViewId,
})
.then(res => {
$self.$clog(res.data);

$self.latestInvoiceViewId = '';
if (res.data.status == 1) {
var resData = res.data.result;

var tempEl = {
__id: resData.invoiceId,
topLeft: resData.sellerName,
topRight: '￥' + (resData.documentType == '50001009' ? (resData.tInvoiceExtendObj && resData.tInvoiceExtendObj.extend17) : resData.amountWithTax),
middleLeft: resData.purchaserName == '' ? '' : '购买方:' + resData.purchaserName,
sellerName: resData.sellerName == '' ? '' : '销售方:' + resData.sellerName,
middleLeft2:
resData.paperDrewDate == ''
? ''
: '发票日期:' + $self.$formatDateTime3(resData.paperDrewDate, 'YYYY-MM-DD'), //上传日期:2018-02-12
middleRight: ' ',
checkStatus: resData.verifyFlag,
signFlag: resData.signFlag,

discernStatus: resData.discernFlag,

reimbursement: resData.processFlag,
uniqueFlag: resData.uniqueFlag,
hasTitle: resData.hasTitle,

status: resData.status,
tags: resData.ext3,
documentType: resData.documentType,
documentTypeName: resData.documentTypeName,

thumbnail: resData.imgUrl, //el.invoiceType == "a" ? el.imgUrl : "", //a表示没有没有识别出来，即识别失败
imgUrl: resData.imgUrl,
timeAgo: 999999999, //文档生成距离当前的时间间隔
__data: resData, //调用接口发过来的原始数据
};

if (
!(
resData.invoiceNo == '' &&
resData.invoiceCode == '' &&
resData.extInfo == '' &&
resData.paperDrewDate == ''
)
) {
tempEl.thumbnail = '';
}


if (tempEl.middleLeft2 == '') {
tempEl.middleLeft2 = '上传日期:' + $self.$formatDateTime2(resData.createTime, 'YYYY-MM-DD');
}
if (tempEl.topLeft == '') {
tempEl.topLeft = '票据影像';
}


tempEl.timeAgo = Math.abs(
new Date($self.$formatDateTime2(resData.createTime, 'YYYY/MM/DD HH:mm:ss')).getTime() -
nowTime
);




switch (tempEl.documentType) {
case '50001009':
if (tempEl.__data.extInfo.length != 0) {
try {
var tempExtInfo = JSON.parse(tempEl.__data.extInfo);
tempExtInfo.map(function (item) {
if (item.key == 'flight_no') {
tempEl.topLeft = '飞机航班:' + item.value;
}
if (item.key == 'start_city') {
tempEl.middleLeft = item.value;
}
if (item.key == 'end_city') {
tempEl.middleLeft += ' -> ' + item.value;
}
if (item.key == 'date') {
tempEl.middleLeft2 = '出行日期:' + item.value;
}
});
} catch (error) {
console.log(error);
}
}
break;

case '50001010':
if (tempEl.__data.extInfo.length != 0) {
try {
var tempExtInfo = JSON.parse(tempEl.__data.extInfo);
tempExtInfo.map(function (item) {
if (item.key == 'train_no') {
tempEl.topLeft = '火车车次:' + item.value;
}
if (item.key == 'start_city') {
tempEl.middleLeft = item.value;
}
if (item.key == 'end_city') {
tempEl.middleLeft += ' -> ' + item.value;
}
if (item.key == 'date') {
tempEl.middleLeft2 = '出行日期:' + item.value;
}
});
} catch (error) {
console.log(error);
}
}
break;

case '50001011':
if (tempEl.__data.extInfo.length != 0) {
try {
var tempExtInfo = JSON.parse(tempEl.__data.extInfo);
tempEl.topLeft = '出租车票';
tempExtInfo.map(function (item) {
if (item.key == 'start_time') {
tempEl.middleLeft =
'上车:' + $self.$dateFormat(item.value, 'YYYY-MM-DD HH:mm');
}
if (item.key == 'end_time') {
tempEl.middleLeft2 =
'下车:' + $self.$dateFormat(item.value, 'YYYY-MM-DD HH:mm');
}
});
} catch (error) {
console.log(error);
}
}
break;
}

var tempInvoices2 = JSON.parse(JSON.stringify($self.invoices));
for (var i = 0; i < tempInvoices2.length; i++) {
var el1 = tempInvoices2[i];
if (el1.__id == tempEl.__id) {
el1 = tempEl;
tempInvoices2[i] = el1;
break;
}
}
$self.invoices = tempInvoices2;

if ($self.invoices.length > 0) {

var totalAmount = 0;
$self.invoices.forEach(function (ell) {
if (!(parseFloat(ell.__data.amountWithTax).toString() == 'NaN')) {
totalAmount += parseFloat(ell.__data.amountWithTax);
}
});
}
}
$self.$nextTick(() => {
setTimeout(function () {
$self.$refs.scroller1.reset();
}, 1000);
});

if (callback) {
callback();
}
});
},

loadData(firstLoad, callback) {
var $self = this;
if (firstLoad) {
$self.search.pageIndex = 1;
} else {
$self.search.pageIndex += 1;
}
var params = {
documentType: $self.search.typeId,
invoiceDate: $self.search.date,
verifyFlag: '',
discrenFlag: 10,
processFlag: '',
keyword: $self.search.keyword,
page: $self.search.pageIndex,
rows: $self.search.pageSize,
};
if ($self.search.statusId.indexOf('discern_') > -1) {
params.verifyFlag = $self.search.statusId.split('discern_')[1];
} else if ($self.search.statusId.indexOf('reimbursement_') > -1) {
params.processFlag = $self.search.statusId.split('reimbursement_')[1];
}else if($self.search.statusId.indexOf('invoiceFlag_') > -1){
params.invoiceFlag = $self.search.statusId.split('invoiceFlag_')[1];
}else if($self.search.statusId.indexOf('uniqueFlag_') > -1){
params.uniqueFlag = $self.search.statusId.split('uniqueFlag_')[1];
}
if ($self.depponReismType === depponReimBurseType.BP) {
params.label = $self.search.depponTag;
}

var nowTime = new Date().getTime();


$self.$webapi[$self.viewType == 'muti' ? 'listInvoice' : 'singleInvoiceList'](params).then(res => {
$self.$vux.loading.hide()
$self.$clog(res.data);



if (res.data.status == 1) {

$self.allSelect = false;
$self.selected = false;
if (res.data.result.list.length == 0) {


if (!firstLoad) {
$self.search.pageIndex--;
}
}
var tempInvoices = res.data.result.list.map(function (el) {
var tempEl = {
__id: el.invoiceId,
topLeft: el.sellerName,
signFlag: el.signFlag,
topRight: '￥' + (el.documentType == '50001009' ? el.tInvoiceExtendObj.extend17 : el.amountWithTax),
middleLeft: el.purchaserName == '' ? '' : '购买方:' + el.purchaserName,
sellerName: el.sellerName == '' ? '' : '销售方:' + el.sellerName,
middleLeft2:
el.paperDrewDate == ''
? ''
: '发票日期:' + $self.$formatDateTime3(el.paperDrewDate, 'YYYY-MM-DD'), //上传日期:2018-02-12
middleRight: ' ',
checkStatus: el.verifyFlag,
verifyFlag: el.verifyFlag,

discernStatus: el.discernFlag,
discernFlag: el.discernFlag,
extractFlag: el.extractFlag,

reimbursement: el.processFlag,
processFlag: el.processFlag,
exceptionStatus:el.exceptionStatus,
uniqueFlag: el.uniqueFlag,
invoiceFlag: el.invoiceFlag,
redFlag: el.redFlag,
hasTitle: el.hasTitle,
status: el.status,
tags: el.ext3,
fullInfoFlag:el.fullInfoFlag,


documentType: el.documentType,
groupFlag: el.groupFlag,
documentTypeName: el.documentTypeName,

thumbnail: el.imgUrl, //el.invoiceType == "a" ? el.imgUrl : "", //a表示没有没有识别出来，即识别失败
imgUrl: el.imgUrl,
timeAgo: 999999999,
__data: el, //调用接口发过来的原始数据
};
tempEl.selected = false;
if (
!(el.invoiceNo == '' && el.invoiceCode == '' && el.extInfo == '' && el.paperDrewDate == '')
) {
tempEl.thumbnail = '';
}


if (tempEl.middleLeft2 == '') {
tempEl.middleLeft2 = '上传日期:' + $self.$formatDateTime2(el.createTime, 'YYYY-MM-DD');
}
if (tempEl.topLeft == '') {
tempEl.topLeft = '票据影像';
}

tempEl.timeAgo = Math.abs(
new Date($self.$formatDateTime2(el.createTime, 'YYYY/MM/DD HH:mm:ss')).getTime() - nowTime
);









switch (tempEl.documentType) {
case '50001009':
if (tempEl.__data.extInfo.length != 0) {
try {
var tempExtInfo = JSON.parse(tempEl.__data.extInfo);

tempExtInfo.map(function (item) {
if (item.key == 'flight_no') {
tempEl.topLeft = '飞机航班:' + item.value;
}
if (item.key == 'start_city') {
tempEl.middleLeft = item.value;
}
if (item.key == 'end_city') {
tempEl.middleLeft += ' -> ' + item.value;
}
if (item.key == 'date') {
tempEl.middleLeft2 = '出行日期:' + item.value;
}
});
} catch (error) {
console.log(error);
}
}
break;

case '50001010':
if (tempEl.__data.extInfo.length != 0) {
try {
var tempExtInfo = JSON.parse(tempEl.__data.extInfo);
tempExtInfo.map(function (item) {
if (item.key == 'train_no') {
tempEl.topLeft = '火车车次:' + item.value;
}
if (item.key == 'start_city') {
tempEl.middleLeft = item.value;
}
if (item.key == 'end_city') {
tempEl.middleLeft += ' -> ' + item.value;
}
if (item.key == 'date') {
tempEl.middleLeft2 = '出行日期:' + item.value;
}
});
} catch (error) {
console.log(error);
}
}
break;

case '50001011':
if (tempEl.__data.extInfo.length != 0) {
try {
var tempExtInfo = JSON.parse(tempEl.__data.extInfo);
tempEl.topLeft = '出租车票';
tempExtInfo.map(function (item) {
if (item.key == 'start_time') {
tempEl.middleLeft =
'上车:' + $self.$dateFormat(item.value, 'YYYY-MM-DD HH:mm');
}
if (item.key == 'end_time') {
tempEl.middleLeft2 =
'下车:' + $self.$dateFormat(item.value, 'YYYY-MM-DD HH:mm');
}
});
} catch (error) {
console.log(error);
}
}
break;
}
return tempEl;
});
if (firstLoad) {
$self.invoices = tempInvoices;
} else {
$self.invoices = $self.invoices.concat(tempInvoices);
}

if ($self.invoices.length > 0) {

var totalAmount = 0;
$self.invoices.forEach(function (ell) {
if (!(parseFloat(ell.__data.amountWithTax).toString() == 'NaN')) {
totalAmount += parseFloat(ell.__data.amountWithTax);
}
});
}
} else {

if (!firstLoad) {
$self.search.pageIndex--;
}
}
$self.$nextTick(() => {
setTimeout(function () {
if (firstLoad) {
$self.$refs.scroller1.reset({top: 0});               } else {
$self.$refs.scroller1.reset(); 
}
}, 1000);
});

if (callback) {
callback();
}
});
$self.totolAmount(params)
},
totolAmount(params){
delete params.page
delete params.rows
this.$webapi.getAllTotalInfoByCollections(params).then(res => {
if(res.data.code == 1){
this.totalInfo = res.data.message
}
})
},
allSelectedHandler() {
let $self = this;
if ($self.showSelect) {
if ($self.allSelect) {
$self.invoices.forEach(item => {
item.selected = true;
});
} else {
$self.invoices.forEach(item => {
item.selected = false;
});
}
}
},
selectHandler() {
let $self = this;
let selectedInvoices = $self.invoices.filter(item => {
return item.selected;
});
if (selectedInvoices.length === $self.invoices.length) {
$self.allSelect = true;
} else {
$self.allSelect = false;
}
},
changeShowSelectHandler() {
this.showSelect = !this.showSelect;
if (this.showSelect) {
this.optClass = 'text-primary';
} else {
this.optClass = 'text-muted';
}
},
tagsHandler() {
let $self = this;

const selectedInvoices = $self.invoices.filter(item => {
return item.selected;
});
if (!$self.showSelect || selectedInvoices.length === 0) {
return;
}
let hasCommit = selectedInvoices.some(item => {
return item.status === '0';
});
if (hasCommit) {
$self.$vux.toast.show({
text: $self.$t('已提交的发票不能重新编辑标签'),
type: 'text',
});
return
}
$self.$vux.confirm.prompt(this.$t('请输入标签名'), {
title: this.$t('标签'),
confirmText: this.$t('确定'),
cancelText: this.$t('取消'),
inputAttrs: {
type: 'text',
maxlength: 24,
},
onShow() {
},
onCancel() {
},
onConfirm(newVal) {
if (newVal) {
$self.$clog('标签：' + newVal);
const invoiceIds = selectedInvoices.map(item => {
return item.__id;
});
const params = {
label: newVal,
invoices: invoiceIds,
};
$self.$webapi.labelBatchAdd(params).then(res => {
$self.$clog(res.data);
$self.loadData(true);
});
}
},
});
},
deleteHandler() {
let $self = this;

const selectedInvoices = $self.invoices.filter(item => {
return item.selected;
});
if (!$self.showSelect || selectedInvoices.length === 0) {
return;
}
let hasExtract = selectedInvoices.some(item => {
return (
item.extractFlag == $self.invoiceExtractStatus.ExtractSuccess ||
item.extractFlag == $self.invoiceExtractStatus.ExtractSuccess + ''
);
});
if (hasExtract) {
$self.$vux.toast.show({
text: $self.$t('已抽取的发票不能删除'),
type: 'text',
});
return;
}
$self.$vux.confirm.show({
title: this.$t('提示'),
content: this.$t('删除警告'),
confirmText: this.$t('确定'),
cancelText: this.$t('取消'),
onCancel() {
},
onConfirm() {
let invoiceIds = []
let taskIds = []



for(let item of selectedInvoices){
if(item.documentType == 10){
taskIds.push(item.__data.taskId)
}else {
invoiceIds.push(item.__data.invoiceId)
}
}
const params = {
invoiceId: invoiceIds,
taskId:taskIds
};
$self.$webapi.deleteInvoiceBatch(params).then(res => {
$self.$clog(res.data);
if (res.data.status == 1) {
$self.loadData(true);
$self.$vux.toast.show({
text: $self.$t('操作成功'),
type: 'text',
});
} else {
$self.$vux.toast.show({
text: res.data.msg,
type: 'text',
});
}
});
},
});
},
getId(params){
return params.documentType == 10 ? params.__data.taskId : params.__data.invoiceId
},
commitHandler() {
let $self = this;

const selectedInvoices = $self.invoices.filter(item => {
return item.selected;
});
if (!$self.showSelect || selectedInvoices.length === 0) {
return;
}
let noTags = selectedInvoices.some(item => {
return !item.tags;
});
let hasCommit = selectedInvoices.some(item => {
return item.status === '0';
});
if (noTags) {
$self.$vux.toast.show({
text: $self.$t('未打标签的发票不能提交'),
type: 'text',
});
return;
}
if (hasCommit) {
$self.$vux.toast.show({
text: $self.$t('不能重复提交'),
type: 'text',
});
return;
}
$self.$vux.confirm.show({
title: this.$t('提示'),
content: this.$t('提交警示'),
confirmText: this.$t('确定'),
cancelText: this.$t('取消'),
onCancel() {
},
onConfirm(newVal) {
const invoiceIds = selectedInvoices.map(item => {
return item.__id;
});
const params = {
invoices: invoiceIds,
};
$self.$webapi.invoiceBatchCommit(params).then(res => {
$self.$clog(res.data);
if (res.data.status == 1) {
$self.loadData(true);
$self.$vux.toast.show({
text: $self.$t('操作成功'),
type: 'text',
});
} else {
$self.$vux.toast.show({
text: res.data.msg,
type: 'text',
});
}
});
},
});
},
changePullupStatus(enabled) {
var $self = this;
if (enabled) {
$self.$refs.scroller1.enablePullup();
$self.pullupEnabled = true;
} else {
$self.$refs.scroller1.disablePullup();
$self.pullupEnabled = false;
}
},

showDatePicker() {
var $self = this;
$self.$vux.datetime.show({
cancelText: this.$t('取消'),
confirmText: this.$t('确定'),
clearText:'不限时间',
format: 'YYYY-MM',
value: $self.search.dateDisplayName,
onClear(){
$self.search.date = '';
$self.search.dateDisplayName = '不限时间';
$self.loadData(true);
},
onConfirm(val) {

$self.search.date = val.replace(/-/g, '') + '01';
$self.search.dateDisplayName = val;

$self.loadData(true);
},
});
},
linkToDetailForMobile(invoice) {
var $self = this;
$self.latestInvoiceViewId = invoice.__id;
this.setImgUrl(invoice.__data.imgUrl)
if (invoice.documentType == '10') {//多票
$self.$router.push({
path: '/invoice/moreDetail/' + invoice.__data.taskId,
});
} else {
$self.$router.push({ //普票
path: '/invoice/detail/' + invoice.__id,
});
}
},
setImgUrl(url){
localStorage.setItem("image",url)
},
linkToDetail(invoice) {
},





onDocumentTypePickerChange(val) {
var $self = this;

$self.search.typeId = val[0];
$self.search.type = $self.documentTypeList[0].filter(function (el) {
return el.value == $self.search.typeId;
})[0].name;







$self.loadData(true);
},

onDocumentStatusPickerChange(val) {
var $self = this;
$self.search.statusId = val[0];




$self.search.status = $self.documentStatusList[0].filter(function (el) {
return el.value == $self.search.statusId;
})[0].name;

$self.loadData(true);
},

isZengZhiShuiPiao(documentType, verifyFlag) {
var $self = this;
try {
return (
documentType.indexOf('1000') == 0 ||
documentType.indexOf('2000') == 0 ||
documentType.indexOf('3000') == 0 ||
documentType.indexOf('4000') == 0 ||
documentType.indexOf('50001001') == 0 ||
documentType.indexOf('50001017') == 0 ||
(documentType.indexOf('50001009') == 0 && verifyFlag != '') 
);
} catch (error) {
return false;
}
},

showReimbursement(groupFlag) {
var $self = this;
if (groupFlag == 'futureland') {
return false;
} else {
return true;
}
},

showHasTitle(groupFlag) {
if (groupFlag == tenantCode.shenhua) {
return true;
} else {
return false;
}
},

isFeiJiHuoCheChuZuChe(documentType) {
var $self = this;
return (
documentType.indexOf('50001010') == 0 ||
documentType.indexOf('50001009') == 0 ||
documentType.indexOf('50001011') == 0
);
},

isOtherPiao(documentType) {
var $self = this;
return (
documentType.indexOf('90009999') == 0 ||
documentType.indexOf('50009999') == 0 ||
documentType.indexOf('90001006') == 0
);
},
searchGetResult(val) {
var $self = this;
console.log('on-change', val);
$self.search.depponTag = val;
$self.loadData(true);
},
setSearchFocus() {
this.$refs.search.setFocus();
},
searchResultClick(item) {
window.alert('you click the result item: ' + JSON.stringify(item));
},
getSearchResult(val) {
console.log('on-change2', val);
this.searchResults = val ? getResult(this.searchKey) : [];
},
onSearchSubmit() {
this.$refs.search.setBlur();
},
onSearchFocus() {
console.log('on focus');
},
onSearchCancel() {
let $self = this;
console.log('on cancel');
},

pageGoBack() {
var $self = this;
try {
if (____isAndroid) {
window.androidApi.backCalls();
} else {

window.iosApi.backCalls();
}
} catch (error) {


$self.$router.replace({
path: '/invoice/index',
});
}
},
onSubmit () {
const $self = this;
$self.search.keyword = this.value;
this.value = new String(this.value)
this.$vux.loading.show()
$self.loadData(true);
this.searchLoadDataAndHideMask()
if (document.getElementsByClassName('weui-search-bar__cancel-btn')) {
document.getElementsByClassName('weui-search-bar__cancel-btn')[0].click();
}
},
searchLoadDataAndHideMask(){
this.search.keyword = this.value;
this.loadData(true);
this.$refs.headerSearch.setBlur();
this.$refs.headerSearch.cancel()
},
changeViewType(){
this.viewType = this.viewType == 'single' ? 'muti' : 'single'
this.$vux.loading.show()
this.loadData(true)
},
checkWxWork(){
if(____isWxWorkBrowser()){
if(location.href.indexOf("#reloaded") == -1){
location.href=location.href+"#reloaded";
location.reload();
}
}
}
},
};

function getResult(val) {
var rs = [];
for (var i = 0; i < 20; i++) {
rs.push({
title: `${val} result: ${i + 1} `,
other: i,
});
}
return rs;
}
